import { HeaderContent, HeaderTypes, Level2CyoItem, LinkLevel2 } from '@/types/headerHierarchy';
import { HeaderContentPro } from '@/types/spreadshirtProHeader';
import { routing } from '@/i18n/routing';
import { Locale } from '@/utility/locale';
import { sanitizePathname } from './urls';

export const isProHeaderContent = (
  content: HeaderContent | HeaderContentPro
): content is HeaderContentPro => {
  return content.content.headerType === HeaderTypes.SPREADSHIRT_PRO;
};

export const isCYOItem = (item: LinkLevel2): item is Level2CyoItem => {
  return item.content._meta.schema === 'https://spreadshirt.com/site/header/navigation-cyo-button';
};

export const getB2BorSpreadshirtLink = (content: HeaderContent | HeaderContentPro) => {
  return isProHeaderContent(content) ? content.content.spreadshirtLink : content.content.b2bLink;
};

export const getIsLocalizedCyoPath = (locale: Locale, pathname: string) => {
  const localizedCyoPath = (
    routing.pathnames['/cyo/assortment/list/[[...slug]]'] as Record<string, string>
  )[locale];
  const keyword = localizedCyoPath?.split('/').slice(1)[0];

  return pathname.startsWith('/' + keyword);
};

export const getRelativeUrl = (url: string) => {
  if (url?.startsWith('http')) {
    const newUrl = new URL(url);
    const urlSegements = newUrl.pathname.split('/');
    const sanitizedPath = urlSegements
      .map((part) => sanitizePathname(decodeURIComponent(part)))
      .join('/');
    let slug = sanitizedPath + newUrl.search + newUrl.hash;
    if (slug.length > 1 && slug.endsWith('/')) {
      slug = slug.slice(0, -1);
    }
    return slug;
  } else {
    console.warn('Invalid URL: ', url);
    return url;
  }
};
